(function () {
  'use strict';

  /* @ngdoc object
   * @name crewViolations
   * @description
   *
   */
  angular
    .module('doubleSectorCount', [
      'ui.router'
    ]);
}());
